import {fsa, fsaPayload, fsaPayloadByKeys, fsaError} from './helpers'

export const ADD_EVENT = 'add new empty event'
export const addEvent = fsa(ADD_EVENT)

export const ADD_CURRENT_EVENT_TO_ALL_EVENTS = 'add current event to all events'
/**
 * @param {Object} payload Info about the current event
 * @param {String} payload.currentEventIsInAll Whether the current event is already in "all events"
 */
export const addCurrentEventToAllEvents = fsaPayload(ADD_CURRENT_EVENT_TO_ALL_EVENTS)

export const CHANGE_CURRENT_EVENT = 'change current event'
export const changeCurrentEvent = fsaPayloadByKeys(CHANGE_CURRENT_EVENT, ['eventId'])

export const CHANGE_CURRENT_EVENT_COMPLETED = 'change current event completed'
export const changeCurrentEventCompleted = fsa(CHANGE_CURRENT_EVENT_COMPLETED)

export const CHANGE_CURRENT_EVENT_FAILURE = 'change current event failure'
export const changeCurrentEventFailure = fsaError(CHANGE_CURRENT_EVENT_FAILURE)

export const CHANGE_CURRENT_EVENT_PENDING = 'change current event pending'
export const changeCurrentEventPending = fsa(CHANGE_CURRENT_EVENT_PENDING)

export const CHANGE_CURRENT_EVENT_SUCCESS = 'change current event succeeded'
export const changeCurrentEventSuccess = fsaPayload(CHANGE_CURRENT_EVENT_SUCCESS)

export const CLEAR_CURRENT_EVENT = 'clear out current event details'
export const clearCurrentEvent = fsa(CLEAR_CURRENT_EVENT)

export const CREATE_NEW_EVENT = 'create new event'
export const createNewEvent = fsaPayloadByKeys(CREATE_NEW_EVENT, ['callback'])

export const CREATE_NEW_EVENT_FAILURE = 'create new event failure'
export const createNewEventFailure = fsaError(CREATE_NEW_EVENT_FAILURE)

export const CREATE_NEW_EVENT_SUCCESS = 'create new event succeeded'
export const createNewEventSuccess = fsaPayload(CREATE_NEW_EVENT_SUCCESS)

export const DELETE_EVENT = 'delete event'
export const deleteEvent = fsaPayloadByKeys(DELETE_EVENT, ['eventId'])

export const DELETE_EVENT_FAILURE = 'delete event failure'
export const deleteEventFailure = fsa(DELETE_EVENT_FAILURE)

export const DELETE_EVENT_SUCCESS = 'delete event succeeded'
export const deleteEventSuccess = fsaPayload(DELETE_EVENT_SUCCESS)

export const EDIT_IN_PROGRESS_EVENT = 'edit in-progress event'
export const editInProgressEvent = fsaPayloadByKeys(EDIT_IN_PROGRESS_EVENT, ['eventId'])

export const GET_ALL_EVENTS = 'get all events'
export const getAllEvents = fsa(GET_ALL_EVENTS)

export const GET_ALL_EVENTS_PENDING = 'get all events pending'
export const getAllEventsPending = fsa(GET_ALL_EVENTS_PENDING)

export const GET_ALL_EVENTS_FAILURE = 'get all events failure'
export const getAllEventsFailure = fsaError(GET_ALL_EVENTS_FAILURE)

export const GET_ALL_EVENTS_SUCCESS = 'get all events succeeded'
export const getAllEventsSuccess = fsaPayload(GET_ALL_EVENTS_SUCCESS)

export const SUBMIT_EVENT_DETAIL_CHANGE_VIA_DASHBOARD = 'submit event detail change via dashboard'
export const submitEventDetailChangeViaDashboard = fsaPayloadByKeys(
  SUBMIT_EVENT_DETAIL_CHANGE_VIA_DASHBOARD,
  ['detail', 'detailType'],
)

export const SUBMIT_EVENT_NUM_MEMBERS_CHANGE_VIA_DASHBOARD =
  'submit event num members change via dashboard'
export const submitEventNumMembersChangeViaDashboard = fsaPayload(
  SUBMIT_EVENT_NUM_MEMBERS_CHANGE_VIA_DASHBOARD,
)

export const SUBMIT_EVENT_OWNER_ROLE_CHANGE_VIA_DASHBOARD =
  'submit event owner role change via dashboard'
export const submitEventOwnerRoleChangeViaDashboard = fsaPayload(
  SUBMIT_EVENT_OWNER_ROLE_CHANGE_VIA_DASHBOARD,
)

export const UPDATE_CURRENT_DATE = 'update current event date'
export const updateCurrentDate = fsaPayload(UPDATE_CURRENT_DATE)

export const UPDATE_CURRENT_EVENT = 'update current event'
export const updateCurrentEvent = fsaPayload(UPDATE_CURRENT_EVENT)

export const UPDATE_CURRENT_NUM_MEMBERS = 'update current event number of renters'
export const updateCurrentNumMembers = fsaPayload(UPDATE_CURRENT_NUM_MEMBERS)

export const UPDATE_CURRENT_OWNER_ROLE = 'update current event owner role'
export const updateCurrentOwnerRole = fsaPayload(UPDATE_CURRENT_OWNER_ROLE)

export const UPDATE_CURRENT_TYPE = 'update current event type'
export const updateCurrentType = fsaPayload(UPDATE_CURRENT_TYPE)

export const UPDATE_PARTNER_INFO = 'events/update partner info'
/**
 * @param {Object} payload                Partner info to update
 * @param {String} payload.email          Partner email address
 * @param {String} [payload.eventId]      The event ID to post partner info for
 * @param {String} payload.firstName      Partner first name
 * @param {Bool}   payload.isEmailOptedIn Whether the partner chooses to subscribe to email updates
 * @param {String} payload.lastName       Partner last name
 * @param {String} payload.origin         Where in the site the info is being saved from
 */
export const updatePartnerInfo = fsaPayload(UPDATE_PARTNER_INFO)

export const UPDATE_PARTNER_INFO_PENDING = 'events/update partner info pending'
export const updatePartnerInfoPending = fsa(UPDATE_PARTNER_INFO_PENDING)

export const UPDATE_PARTNER_INFO_FAILURE = 'events/update partner info failure'
export const updatePartnerInfoFailure = fsaError(UPDATE_PARTNER_INFO_FAILURE)

export const UPDATE_PARTNER_INFO_SUCCESS = 'events/update partner info succeeded'
export const updatePartnerInfoSuccess = fsaPayload(UPDATE_PARTNER_INFO_SUCCESS)
